export default __webpack_public_path__ + "static/media/shawgo_logo_small.c84d0d17.png";